import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  // tooltipContainerStyle: {
  //   backgroundColor: colors.neutral.charcoal,
  //   borderRadius: scale(8),
  //   paddingHorizontal: scale(12),
  //   paddingVertical: scale(8),
  //   alignSelf: 'center',
  //   // this ensures text doesn't overflow:
  //   flexShrink: 1,
  // },

  backdrop: {
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.2)',
    flex: 1,
    justifyContent: 'center',
  },
  fullscreenOverlay: {
    backgroundColor: 'transparent',
    flex: 1,
    position: 'relative',
  },

  tooltipContainerStyle: {
    backgroundColor: colors.neutral.charcoal,
    borderRadius: scale(8),
    elevation: 5,
    padding: scale(8),
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
});
export default styles;
